// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        // галерея выполненных работ
        $('.article .field--name-body p.text-images').photobox('a',{ time:0 });

        // слайдер на главной
        // $('.slider_block .field--name-field-paragraph-block').slick({
        //     dots: true,
        //     infinite: true,
        //     speed: 500,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: false
        // });

        // add now year
        var currentYear = new Date().getFullYear();
        $(".copyright_box .now_year").prepend(currentYear+" ");

        function checkMyCookies(){
            let cookieDate = localStorage.getItem('cookieDate');
            let cookieNotification = document.getElementById('cookie_notifys');
            let cookieBtn = cookieNotification.querySelector('.notifys__apply');
            if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
                cookieNotification.classList.add('show');
            }
            cookieBtn.addEventListener('click', function(){
                localStorage.setItem( 'cookieDate', Date.now() );
                cookieNotification.classList.remove('show');
            })
        }
        checkMyCookies();

    });
})(jQuery);